import * as React from 'react';

function StarRewards(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.123 17.39l-2.744-2.175a.61.61 0 00-.76 0L8.877 17.39l1.058-3.557a.694.694 0 00-.23-.735l-2.787-2.212h3.431c.277 0 .52-.186.608-.47L12 6.907l1.047 3.514c.084.28.327.467.605.467h3.43l-2.795 2.216a.699.699 0 00-.251.537c0 .044.018.162.03.205l1.057 3.546zm3.454-6.591c.141-.114.2-.31.142-.488a.418.418 0 00-.394-.299H13.8l-1.401-4.705A.42.42 0 0011.999 5a.42.42 0 00-.398.308l-1.397 4.704H5.675a.42.42 0 00-.395.299.451.451 0 00.143.488L9.1 13.713l-1.406 4.718a.451.451 0 00.158.488.405.405 0 00.492-.009l3.656-2.9 3.66 2.901a.397.397 0 00.49.008.45.45 0 00.158-.488l-1.413-4.712 3.683-2.92z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.583 13.67H5.298l-.4-1.362c-.107-.367-.689-.367-.796 0l-.4 1.363H2.417a.42.42 0 00-.395.297.451.451 0 00.141.487l1.057.848-.405 1.38a.448.448 0 00.16.488.399.399 0 00.49-.012l1.035-.83 1.035.83a.4.4 0 00.49.011.448.448 0 00.16-.488l-.406-1.379 1.058-.848a.451.451 0 00.141-.488.421.421 0 00-.395-.296zM21.978 13.968a.42.42 0 00-.395-.297h-1.285l-.4-1.362c-.107-.368-.688-.368-.796 0l-.4 1.362h-1.286a.417.417 0 00-.394.297.45.45 0 00.142.488l1.056.848-.405 1.38a.45.45 0 00.16.488.404.404 0 00.49-.012l1.035-.83 1.036.83c.142.115.342.12.49.01a.45.45 0 00.16-.487l-.406-1.38 1.056-.847a.452.452 0 00.142-.488z"
        fill="currentColor"
      />
    </svg>
  );
}

export default StarRewards;
